export default "__VITE_ASSET__DDcNHxyG__"